













































































































































































































































































import Vue from 'vue'
import { DataTreeNode } from '@/utils/array'
import { getUserInfo } from '@/utils/auth'
import { WorkStationGroupServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { ShiftServiceProxy } from '@/service-proxies/app-v2/time.service-proxies'
import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import dayjs from 'dayjs'
import moment from 'moment'
const ssp = new ShiftServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy()
const tssp = new TenantSettingServiceProxy()

export default Vue.extend({
  name: 'left-tree',
  data() {
    return {
      filter: {
        endDate: '',
        startDate: '',
        productivityType: 'RUNNING',
        statisticalMethod: 'SHIFT',
        shiftList: [],
        workStationList: [],
        productName:'',
        start: null,
        end: null,
        date: null,
        iotStatus: [],
        duration: 5,
      },
      iotStatus: undefined,
      range: {
        rangeMode: ['date', 'date']
      },
      checkShift: [],
      rangeData: [null, null],
      checkedKeys: [],
      expendKeys: [],
      treeData: [],
      workStatoinItems: [],
      shiftIndexs: [],
      cilentHeight: '260px',
      defaultNumberChecked: 0,
      recordId:'',
      saveIndex:0
    }
  },
  props: {
    init: {
      type: Array, // ['productivity','statistical','shift','time','tree']
      default: () => []
    },
    queryKey:{
      type:String,
      default:''
    }
  },
  watch: {
    iotStatus: {
      handler(val) {
        if (val) {
          this.filter.iotStatus = [val]
        } else {
          this.filter.iotStatus = []
        }
      },
      immediate: true
    }
  },
  created() {
    this.rangeData[0] = dayjs()
      .subtract(6, 'day')
      .valueOf()
    this.rangeData[1] = dayjs().valueOf()
    this.treeData = []
    this.getShift()
  },
  updated() {
    this.getCilentHeight()
  },
  methods: {
    moment,
    showItem(val) {
      // console.log(val)
    },
    getCilentHeight() {
      const cilent = document.getElementById('leftTreeSelect')
      this.cilentHeight = cilent.clientHeight + 70 + 'px'
    },
    getShift() {
      this.shiftIndexs = []
      this.checkShift = []
      ssp.getShiftIndexName().then((res) => {
        if (res.keyNameDTOList) {
          this.shiftIndexs = res.keyNameDTOList
          this.$emit('getShiftList', this.shiftIndexs)
          res.keyNameDTOList.forEach((res) => {
            this.checkShift.push(res.key)
          })
        }
        this.getTreeList()
      })
    },
    expandKey(value) {
      this.expendKeys = value
    },
    async getTreeList() {
      this.workStatoinItems = []
      this.expendKeys = []
      this.checkedKeys = []
      const userId = this.getUserId()
      let tracList = []
      let result = await tssp.detailConditions(userId,this.queryKey,'','','','')
      if(result.length>0){
        this.recordId = result[0].id
        tracList = JSON.parse(result[0].paramValue)
      }

      wsgsp.workStationGroupList().then((res) => {
        if (res) {
          const keys = []
          // let i = 0
          const data = res.reduce((total, value) => {
            const key = value.id + '-' + value.parentId
            total.push({
              ...value,
              key: key,
            })
            // if(value.isWorkStation){
            //   if(i < 5){
            //     keys.push(key)
            //     i = 1 + i
            //     console.log(keys);

            //   }
            // } else {
            //   this.expendKeys.push(key)
            // }
            return total
          }, [])


          this.treeData = DataTreeNode.arrayToTree(data)
          this.treeData.map((item) => {
            item.scopedSlots = {
              title: 'custom'
            }
            if (item.children && item.children.length) {
              item.children.map((t) => {
                t.scopedSlots = {
                  title: 'custom'
                }
                this.getTreeSelect(t, keys)
              })
            } else {
               if (this.defaultNumberChecked < 5) {
                  keys.push(item.key)
                  this.defaultNumberChecked = this.defaultNumberChecked + 1
               }
            }
          })
          // console.log(this.treeData,'树数据')

          this.workStatoinItems = data
          this.checkedKeys = tracList.length>0?tracList:keys
          this.handelSearch()
        }
      })
    },
    getTreeSelect(data, arr) {
      if (data.children && data.children.length) {
        data.children.map((m) => {
          m.scopedSlots = {
            title: 'custom'
          }
          this.getTreeSelect(m, arr)
        })
      } else {
        if (this.defaultNumberChecked < 5) {
          arr.push(data.key)

          this.defaultNumberChecked = this.defaultNumberChecked + 1
        }
      }
      return arr
    },
    addKeyId(item) {
      const key = item.id + '-' + item.parentId
      return key
    },
    setWorkStationList() {
      const List = []
      const recheckKeys = []
      // console.log('workStatoinItems:', this.workStatoinItems)
      // console.log(this.checkedKeys)
      this.workStatoinItems.map((res) => {
        if (
          this.checkedKeys.includes(this.addKeyId(res)) &&
          !recheckKeys.includes(res.id) &&
          !res.isGroup
        ) {
          recheckKeys.push(res.id)
          const data = {
            key: res.id,
            name: res.title,
            code: res.code,
            standardEfficiency: res.standardEfficiency
          }
          List.push(data)
        }
      })
      return List
    },
    handelSearch() {
      this.filter.workStationList = []
      this.filter.shiftList = []
      this.filter.date = this.filter.date ? dayjs(this.filter.date).format('YYYY-MM-DD') : dayjs(new Date()).format('YYYY-MM-DD')

      if (this.filter.statisticalMethod === 'MONTH') {
        const startDate = dayjs(this.rangeData[0]).startOf('month')
        const endDate = dayjs(this.rangeData[1]).endOf('month')
        this.filter.startDate = dayjs(startDate).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(endDate).format('YYYY-MM-DD')
      } else if (this.filter.statisticalMethod === 'WEEK') {
        const startDate = dayjs(this.rangeData[0])
          .startOf('week')
          .add(1, 'day')
          .valueOf()
        const endDate = dayjs(this.rangeData[1])
          .endOf('week')
          .add(1, 'day')
          .valueOf()
        this.filter.startDate = dayjs(startDate).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(endDate).format('YYYY-MM-DD')
      } else {
        this.filter.startDate = dayjs(this.rangeData[0]).format('YYYY-MM-DD')
        this.filter.endDate = dayjs(this.rangeData[1]).format('YYYY-MM-DD')
      }
      if(!this.init.includes('product')){
        delete this.filter.productName
      }
      this.filter.workStationList = this.setWorkStationList()
      this.shiftIndexs.map((res) => {
        if (this.checkShift.includes(res.key)) {
          const data = {
            key: res.key,
            name: res.name
          }
          this.filter.shiftList.push(data)
        }
      })
      if (dayjs(this.rangeData[0]).valueOf() > dayjs(this.rangeData[1]).valueOf()) {
        this.$message.warning('开始时间不能大于结束时间')
        return
      }
      if (this.filter.workStationList.length < 1) {
        this.$message.warning(this.$t('page_time_analysis_selectworkstation'))
        return
      }
      if (this.filter.statisticalMethod === 'SHIFT' && this.filter.shiftList < 1) {
        this.$message.warning('请选择班次')
        return
      }
      if(this.saveIndex>0){
        this.saveSelectInfo()
      }
      this.saveIndex = this.saveIndex+1
      this.$emit('search', this.filter)
    },

    hanldeOutPut() {
      this.$emit('outPut')
    },

    selectStatisticalMethod(value) {
      if (value === 'DAY' || value === 'SHIFT') {
        this.range.rangeMode = ['date', 'date']
      } else if (value === 'MONTH') {
        this.range.rangeMode = ['month', 'month']
      }
      this.getCilentHeight()
      this.filter.statisticalMethod = value
    },

    selectShiftIndexs(value) {
      this.checkShift = value
    },

    selectProductivityType(value) {
      this.filter.productivityType = value
    },

    handlePanelChange(value, mode) {
      this.rangeData = value
      this.range.rangeMode = [
        mode[0] === 'date' ? 'month' : mode[0],
        mode[1] === 'date' ? 'month' : mode[1]
      ]
    },

    rangeChange(value) {
      this.rangeData = value
    },

    weekStrartChange(value) {
      this.$set(this.rangeData, 0, dayjs(value).format('YYYY-MM-DD'))
    },

    weekEndChange(value) {
      this.$set(this.rangeData, 1, dayjs(value).format('YYYY-MM-DD'))
    },

    onSelect(value) {
      // console.log(value)
      this.checkedKeys = value
    },

    async saveSelectInfo(){
      const userId = this.getUserId()
      let arr = []
      this.workStatoinItems.map(res=>{
        if (
          this.checkedKeys.includes(this.addKeyId(res)) &&!res.isGroup
        ){
          arr.push(res.id + '-' + res.parentId)
        }
      })
      const body:any = {
        paramName:this.queryKey,
        paramKey:userId,
        paramValue:JSON.stringify(arr),
        id:this.recordId
      }
      await tssp.submit(body)
    },
    getUserId() {
      const info = getUserInfo()
      return info.user_id || ''
    },
    productChange(e){
      this.filter.productName = e.target.value
    }
  }
})
